// LICENSE_CODE ZON
'use strict'; /*jslint react:true*/
import React from 'react';
import {Text} from '../../comp/text';
import store from '../../store.js';
import {Icon} from '../../comp/icon';
import {Tooltip} from '../../comp/tooltip';
import {Referees_table} from './table.js';
import * as cns from './shared.module.less';

export function Connected(){
    const [{list, total},, loading, pagination] = store.use_referees();
    return <div>
      <div className={cns.table_header}>
        <Text.xxl h2>My Referrals</Text.xxl>
        <Tooltip tip="Total invited" placement="top">
          <div className={cns.count_wrap}>
            <div className={cns.ico_wrap}>
              <Icon ico="folks" color="accent"/>
            </div>
            <Text.xxl span title="number of referrals">{total}</Text.xxl>
          </div>
        </Tooltip>
      </div>
      <Referees_table list={list} loading={loading} pagination={pagination}/>
    </div>;
}
